/**
 * Turns an old hash link into a normal one, once, at start-up.
 *
 * The router used hash URLs (`/#/home/cases`). It now uses normal URLs
 * (`/home/cases`), so old bookmarks and emails still need to work.
 * `/#/x?y=1` becomes `/x?y=1`. A hash that is not a route (`#section`, a bare
 * `#`) is left alone. Uses `replaceState`, so there is no reload and no extra
 * history entry.
 */
export function redirectHashUrl(): void {
  const { hash } = window.location;
  if (!hash.startsWith('#/')) {
    return;
  }
  // Collapse extra leading slashes. `#//evil.com` would otherwise become
  // `//evil.com`, which points at another site: replaceState throws on that and
  // the app never mounts. As `/evil.com` it just shows the 404 page.
  const path = '/' + hash.slice(1).replace(/^[/\\]+/, '');
  window.history.replaceState(window.history.state, '', path);
}
